import { SpeakerWaveIcon, SpeakerXMarkIcon } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';
import { setSoundOn, useSound } from '../../lib/sound';
import { buttonClass } from './Button';

/**
 * The one new-order sound switch (top bar). The click is the gesture that unlocks audio and plays the chime once.
 * A single element: icon only below 640 px (the label stays for assistive tech), icon and label from 640 px.
 */
export const SoundToggle = () => {
    const { t } = useTranslation();
    const { on } = useSound();
    const Icon = on ? SpeakerWaveIcon : SpeakerXMarkIcon;
    return (
        <button
            type="button"
            aria-pressed={on}
            aria-keyshortcuts="M"
            onClick={() => void setSoundOn(!on)}
            className={`${buttonClass({ variant: 'outline' })} max-sm:w-11 max-sm:px-0`}
        >
            <Icon className="size-5" aria-hidden="true" />
            <span className="max-sm:sr-only">{on ? t('sound.on') : t('sound.off')}</span>
        </button>
    );
};
